import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Sectors from "./components/Sectors";
import Menu from "./components/Menu";
import Clients from "./components/Clients";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import WhyUs from "./components/WhyUs";
import { captureAttribution } from "./lib/attribution";
import DailyCorporateMeals from "./pages/DailyCorporateMeals";
import EventCatering from "./pages/EventCatering";
import BentoBoxes from "./pages/BentoBoxes";
import PantryManagement from "./pages/PantryManagement";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import SEO from "./components/SEO";
function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
}

function Landing() {
  return (
    <div className="App min-h-screen bg-[#FDFBF7] text-[#1E3A5F]">
      <SEO
        title="Corporate Catering & Office Meals in Bangalore"
        description="Corporate catering and workplace food services in Bangalore for daily office meals, corporate events, packed meal boxes and office pantry management."
        keywords="corporate catering bangalore, office meals bangalore, office lunch delivery, corporate meal boxes, pantry management bangalore"
        canonicalUrl="https://theofficemealco.com/"
        ogImage="/og-image.jpg"
        ogType="website"
      />
      <Navigation />
      <main>
        <Hero />
        <About />
        <Services />
        <Sectors />
        <Menu />
        <WhyUs />
        <Clients />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <BrowserRouter>
    <GoogleAnalyticsTracker />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/daily-corporate-meals" element={<DailyCorporateMeals />} />
        <Route path="/event-catering" element={<EventCatering />} />
        <Route path="/bento-boxes" element={<BentoBoxes />} />
        <Route path="/pantry-management" element={<PantryManagement />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<Navigate to="/#about" replace />} />
        <Route path="/services" element={<Navigate to="/#services" replace />} />
        <Route path="/menu" element={<Navigate to="/#menu" replace />} />
        <Route path="/why-us" element={<Navigate to="/#why-us" replace />} />
        <Route path="/clients" element={<Navigate to="/#clients" replace />} />
        <Route path="/testimonials" element={<Navigate to="/#testimonials" replace />} />
        <Route path="/enquire" element={<Navigate to="/#contact" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1E3A5F",
            color: "#FDFBF7",
            border: "1px solid rgba(253,251,247,0.15)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;